module.exports = React.addons.shallowCompare;


/*****************
 ** WEBPACK FOOTER
 ** external "React.addons.shallowCompare"
 ** module id = 90
 ** module chunks = 0
 **/